import { h } from "preact";
import "./spinner.scss";

export function Spinner(props: { class?: string }) {
    return (
        <div class={"spinner" + (props.class ? (" " + props.class) : "")}>
            <div class="lds-dual-ring"></div>
        </div >
    );
}
